import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Parallax, Mousewheel, EffectFade } from 'swiper/modules';

import Alpine from 'alpinejs'
import $ from 'jquery';

import gsap from 'gsap';

import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupRouteNamePlugin from '@swup/route-name-plugin';



import * as basicLightbox from 'basiclightbox';
import 'lazysizes';
import MasonryReflow from './masonry-reflow';

let aosMode = false;

  // Lightbox

  if (!aosMode){
    //remove link   <link rel="stylesheet" href="https://unpkg.com/aos@next/dist/aos.css" /> from head
    const link = document.querySelector('link[href="https://unpkg.com/aos@next/dist/aos.css"]');
    if (link){
      link.remove();
    }

  }



Array.from(document.querySelectorAll("[data-lightbox]")).forEach(element => {
  element.onclick = (e) => {
    e.preventDefault();
    basicLightbox.create(`<img src="${element.href}">`).show();
  };
});


window.$ = $;
window.introTl; 
window.Alpine = Alpine

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Autoplay = Autoplay;
window.EffectFade = EffectFade;


Alpine.store('data', {
  intro: true,
  about: false,
  index: false,
  showIframe: false,
  iframeSrc: '',
  pageSlug: '',
})


Alpine.start()

if (aosMode){
  AOS.init();
}

let masonryInstances = [];

function init(){

  // if (aosMode){
  //  // add  data-aos="slide-up" to all articles and all section in first section
  //  const firstSection = document.querySelector('section:first-child');
  //  const articles = firstSection.querySelectorAll('article');
  //  const sections = firstSection.querySelectorAll('section');
  //  articles.forEach(article => {
  //   article.setAttribute('data-aos', 'fade-up');
  //  });
  //  sections.forEach(section => {
  //   section.setAttribute('data-aos', 'fade-up');
  //  });
  // }

  Splitting();
  initNonBreakingSpaces();
  initCarousels();

  // Tear down previous masonry instances (important for Swup page transitions)
  masonryInstances.forEach(instance => instance.destroy());
  masonryInstances = MasonryReflow.init();

  // Initialize AOS animations for section/article elements

  

}

function initCarousels() {
  // Initialize regular carousels
  const regularCarousels = document.querySelectorAll('.swiper:not(.image-carousel)');
  
  regularCarousels.forEach((swiperEl) => {
    new Swiper(swiperEl, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: false,
      centeredSlides: true,
      centerInsufficientSlides: true,
      loop: false,
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },

      },
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false,
      //   pauseOnMouseEnter: true,
      // },
      breakpoints: {
        1024: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
      on: {
        slideChange: function () {
          const caption = this.slides[this.activeIndex].dataset.caption;
          swiperEl.querySelector('.swiper-caption').textContent = caption;
          console.log(caption);
        },
        init: function () {
          const caption = this.slides[this.activeIndex].dataset.caption;
          swiperEl.querySelector('.swiper-caption').textContent = caption;
          console.log(caption);
        },
      },
    });

    const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
    swiperWrapper.addEventListener('click', function (e) {
      const rect = this.getBoundingClientRect();
      const x = e.clientX - rect.left; // click X relative to element
    
      if (x > rect.width / 2) {
        if (swiperEl.swiper.isEnd) {
          swiperEl.swiper.slideTo(0);
        } else {
          swiperEl.swiper.slideNext();
        }
      } else {
        swiperEl.swiper.slidePrev();
      }
    });
    // add swiper navigation
  });

  // Initialize image carousels (full-width, single slide)
  const imageCarousels = document.querySelectorAll('.image-carousel');
  
  // imageCarousels.forEach((swiperEl) => {
  //   const slidesCount = parseInt(swiperEl.dataset.slidesCount);
    
  //   new Swiper(swiperEl, {
  //     modules: [Navigation, Pagination, Autoplay],
  //     slidesPerView: 1,
  //     spaceBetween: 30,
  //     slideToClickedSlide: true,
  //     loop: slidesCount > 1,
  //     autoplay: slidesCount > 1 ? {
  //       delay: 5000,
  //       disableOnInteraction: false,
  //     } : false,
  //     navigation: {
  //       nextEl: swiperEl.querySelector('.swiper-button-next'),
  //       prevEl: swiperEl.querySelector('.swiper-button-prev'),
  //     },
  //     pagination: {
  //       el: swiperEl.querySelector('.swiper-pagination'),
  //       clickable: true,
  //       renderBullet: function (index, className) {
  //         return '<span class="' + className + '">' + (index + 1) + "</span>";
  //       },
  //     },
  //   });
  // });
}

function initRandomFooterImages() {
  // Check if footer images are available
  if (!window.footerImages || window.footerImages.length === 0) {
    return;
  }
  
  const footerImage1 = document.getElementById('footer-image-1');
  const footerImage2 = document.getElementById('footer-image-2');
  
  if (!footerImage1 || !footerImage2) {
    return;
  }
  
  // Function to get random images
  function getRandomImages() {
    const images = [...window.footerImages];
    
    if (images.length === 0) {
      return [];
    }
    
    if (images.length === 1) {
      return [images[0], images[0]];
    }
    
    // Shuffle array and take first 2 images
    const shuffled = images.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 2);
  }
  
  // Set random images
  const randomImages = getRandomImages();
  
  if (randomImages.length >= 1) {
    footerImage1.src = randomImages[0];
  }
  
  if (randomImages.length >= 2) {
    footerImage2.src = randomImages[1];
  }
}

init();

const swup = new Swup({
  containers: ["#swup"],
  native:false,
  cache: false,
  animationSelector: false,
  plugins: [
    new SwupHeadPlugin({
      persistTags: 'style[data-keep-style]',

    }), 
    new SwupPreloadPlugin()]

});

swup.hooks.on('page:view', (visit) => {
  init()
});





// Script pour ajouter des espaces insécables selon les règles typographiques françaises
// Utilise l'espace insécable fine (U+202F) pour une meilleure typographie

function addNonBreakingSpaces() {
  // Sélectionner tous les paragraphes et autres éléments de texte
  const textElements = document.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li, span, div');
  const NBSP_FINE = '\u202F'; // Espace insécable fine (U+202F)
  const NBSP = '\u00A0'; // Espace insécable (U+00A0)
  const PUNCT_SPACE = NBSP; // Espace avant ponctuation double (plus visible que NBSP_FINE)
  const NB_HYPHEN = '\u2011'; // Trait d'union insécable (U+2011)
  
  let processedCount = 0;
  
  textElements.forEach(element => {
    // Traiter uniquement les nœuds de texte, pas les éléments avec du HTML complexe
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      // Ignorer les nœuds dans script, style, etc.
      const parent = node.parentElement;
      if (parent && (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE')) {
        continue;
      }
      textNodes.push(node);
    }
    
    textNodes.forEach(textNode => {
      let text = textNode.textContent;
      const originalText = text;
      
      // Règles de typographie française avec espace insécable (idempotentes)
      // Guillemets français : « texte »
      // - normalize any spacing after « to a single NBSP
      text = text.replace(/«[\s\u00A0\u202F]*/g, '«' + PUNCT_SPACE);
      // - normalize any spacing before » to a single NBSP
      text = text.replace(/[\s\u00A0\u202F]*»/g, PUNCT_SPACE + '»');
      
      // Ponctuation double (avant) - ne remplace que s'il y a déjà un espace
      text = text.replace(/(\S)[ \t\u00A0\u202F]+:/g, '$1' + PUNCT_SPACE + ':');
      text = text.replace(/(\S)[ \t\u00A0\u202F]+;/g, '$1' + PUNCT_SPACE + ';');
      text = text.replace(/(\S)[ \t\u00A0\u202F]+!/g, '$1' + PUNCT_SPACE + '!');
      text = text.replace(/(\S)[ \t\u00A0\u202F]+\?/g, '$1' + PUNCT_SPACE + '?');
      
      // Tiret cadratin (dialogue)
      text = text.replace(/\s*—\s*/g, NBSP + '—' + NBSP);
      
      // Pour cent - espace insécable
      text = text.replace(/(\d)\s*%/g, '$1' + NBSP + '%');
      
      // Unités monétaires (euros, dollars) - espace insécable
      text = text.replace(/(\d)\s*€/g, '$1' + NBSP + '€');
      text = text.replace(/(\d)\s*\$/g, '$1' + NBSP + '$');
      
      // Plages de dates (années) - trait d'union insécable
      text = text.replace(/(\d{4})-(\d{4})/g, '$1' + NB_HYPHEN + '$2');
      text = text.replace(/(\d{2})-(\d{2})/g, '$1' + NB_HYPHEN + '$2');

      // multiply sign × — normalize any surrounding whitespace to a single NBSP on each side (idempotent)
      text = text.replace(/[\s\u00A0\u202F]*×[\s\u00A0\u202F]*/g, NBSP + '×' + NBSP);
      
      // Mettre à jour seulement si le texte a changé
      if (text !== originalText) {
        textNode.textContent = text;
        processedCount++;
      }
    });
  });
  
  if (processedCount > 0) {
    console.log(`✓ Espaces insécables ajoutées dans ${processedCount} nœuds de texte`);
  }
}

// Exécuter le script après le chargement du DOM
function initNonBreakingSpaces() {
  addNonBreakingSpaces();
  
  // Observer les changements dynamiques du DOM
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && (node.tagName === 'P' || node.querySelector('p'))) {
          shouldUpdate = true;
        }
      });
    });
    if (shouldUpdate) {
      addNonBreakingSpaces();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}

// Initialiser après le chargement du DOM
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => {
//     initNonBreakingSpaces();
//   });
// } else {
//   initNonBreakingSpaces();
// }